module.exports = __webpack_public_path__ + "static/img/aircab.660f6c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/aircab.png
// module id = fb+g
// module chunks = 363